import type { CardRefundRecord } from "@/firestore/cardRefunds";
import { adminRequest } from "./client";

export interface RefundTransferInput {
  instructionVersion: string;
  txHash: string;
  logIndex: number | null;
  reimbursementAttested: true;
}

export type CardRefundCommand =
  | { action: "claim"; input: Record<string, never> }
  | {
      action: "release-unsent";
      input: {
        authorizationAttemptId: string;
        instructionVersion: string | null;
        noTransferSent: true;
      };
    }
  | { action: "submit-transfer"; input: RefundTransferInput }
  | { action: "correct-transfer-proof"; input: RefundTransferInput & { supersedes: string } }
  | {
      action: "link-original-payment";
      input: { originalPayment: string; confirmedSameOwnerPurchase: true };
    };

/** A command records operator intent; transfer verification continues through backend events. */
export function sendCardRefundCommand(
  token: string,
  id: string,
  updatedAt: string,
  clientRequestId: string,
  command: CardRefundCommand,
): Promise<CardRefundRecord> {
  return adminRequest<CardRefundRecord>({
    method: "POST",
    path: `/admin/card-refunds/${encodeURIComponent(id)}/${command.action}`,
    query: { updatedAt },
    body: { ...command.input, clientRequestId },
    token,
  });
}
